import React from "react"
import AlertBox, { AlertBoxType } from "components/elements/AlertBox/AlertBox"
import Link from "components/elements/Link"

type Props = {
  onClickAddCredits: () => void
}

const InsufficientSMSCreditsAlertBox = ({ onClickAddCredits }: Props) => (
  <AlertBox
    type={AlertBoxType.Warning}
    header="Insufficient Message Credits"
    text={(
      <>
        You don&apos;t have enough message credits for the selected recipients. {" "}
        <Link onClick={onClickAddCredits}>Please refill to continue</Link>.
      </>
      )}
  />
)

export default InsufficientSMSCreditsAlertBox
